/**
 * Created by wangrun on 2017/7/5.
 */
import mianBaoComponent from './mianBao.vue'
const mianBao = {
    install: function(Vue){
        Vue.component('mianBao',mianBaoComponent)
    }
}
export default mianBao